
module.exports = {"attributes":{"width":"28","height":"40"},"content":"<path d=\"M9.4 1.5c5.5 0 7.4 3.3 7.4 9s-2.4 11-8.5 16.3l-8.3 7V40h27.3l.7-7H2.8v-.2l8.5-4.3c10.5-5.2 16.4-9.7 16.4-17.3C27.7 3.8 22.5 0 13.4 0 8.6 0 4 .7.9 2v9h1l3-9c1.7-.4 3.2-.5 4.6-.5z\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
